import type { Epic } from '@mona-roadmap/domain';

/** A deliverable's product area mirrors its (first) Epic's product area. Shared by the mock backend and optimistic updates. */
export function deriveProductArea(epicIds: string[], epicsById: ReadonlyMap<string, Epic>): string | null {
  for (const id of epicIds) {
    const epic = epicsById.get(id);
    if (epic) return epic.productArea;
  }
  return null;
}
